import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

import type LocationModel from './location';

export default class LocationsCapacity extends Model {
  declare [Type]: 'locations-capacity';

  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel>;

  @attr('string')
  declare capacityDate: string;

  @attr('number')
  declare capacityLimit: number;

  @attr('number')
  declare onSiteCount: number;

  @attr('number')
  declare expectedCount: number;

  @attr('number')
  declare inCount: number;

  @attr('number')
  declare outCount: number;

  @attr('boolean')
  declare capacityReached: boolean;
}
